// import React, { useState, useRef, useEffect } from "react";

import NewItemTransform from "../../../../components/@documents/item_transform/NewItemTransform";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemTransformNewPage() {

    return (
        <NewItemTransform 
            routeType={routeTypes.workstation}
        />
    )
}